import { createApp } from 'vue';
import PressRelease from '../components/Articles/PressRelease.vue';

const app = createApp(PressRelease, {});
app.mount('#pressRelease');

// function for sticky navbar
const navbar = document.getElementById('articlesNavbar');
const link1 = document.getElementById('firstLink');
const link2 = document.getElementById('secLink');
const link3 = document.getElementById('lastLink');
const promosAndBlongs = document.querySelectorAll('#secLink', '#lastLink');

function link1Active() {
    link2.classList.add('not-active', 'col-2', 'tw-bg-accentGreen');
    link3.classList.add('not-active', 'col-2', 'tw-bg-darkGreen');

    link2.classList.remove('active', 'col-8');
    link3.classList.remove('active', 'col-8');

    link1.classList.add('active', 'col-8');
    link1.classList.remove('not-active', 'col-2');
}
function link2Active() {
    link1.classList.add('not-active', 'col-2', 'tw-bg-accentGreen');
    link3.classList.add('not-active', 'col-2', 'tw-bg-darkGreen');

    link1.classList.remove('active', 'col-8');
    link3.classList.remove('active', 'col-8');

    link2.classList.add('active', 'col-8');
    link2.classList.remove('not-active', 'col-2');
}
function link3Active() {
    link1.classList.add('not-active', 'col-2', 'tw-bg-accentGreen');
    link2.classList.add('not-active', 'col-2', 'tw-bg-darkGreen');

    link1.classList.remove('active', 'col-8', 'tw-bg-darkGreen');
    link2.classList.remove('active', 'col-8', 'tw-bg-accentGreen');

    link3.classList.add('active', 'col-8');
    link3.classList.remove('not-active', 'col-2');
}
const articleNavbarLinks = document.querySelectorAll('a.articles__navbar-link');
const scrollToFirstSection = document.querySelector('.article__first-section');
const scrollToSecondSection = document.querySelector(
    '.article__second-section'
);
const scrollToLastSection = document.querySelector('.article__last-section');

const news = document.querySelector('#articles');
const news_Get_Position = news.getBoundingClientRect();
const news_Get_Y_Position = parseInt(
    news_Get_Position.top - navbar.offsetHeight
);

const pressRelease = document.querySelector('#pressRelease');
const pressRelease_Get_Position = pressRelease.getBoundingClientRect();
const pressRelease_Get_Y_Position = parseInt(
    pressRelease_Get_Position.top - navbar.offsetHeight
);

const blogs = document.querySelector('#blogs');
const blogs_Get_Position = blogs.getBoundingClientRect();
const blogs_Get_Y_Position = parseInt(
    blogs_Get_Position.bottom - navbar.offsetHeight
);

const onScroll = () => {
    const scroll = document.documentElement.scrollTop;

    if (scroll > 100) {
        navbar.classList.add('sticky');

        link1Active();
        if (
            scroll >= pressRelease_Get_Y_Position &&
            scroll <= blogs_Get_Y_Position
        ) {
            link2Active();
        }
        if (scroll >= blogs_Get_Y_Position) {
            link3Active();
        }
    } else {
        navbar.classList.remove('sticky');
    }
};
window.addEventListener('scroll', onScroll);

// scroll to a section when clicking navbar links
const clickNavbarLinkFunction = function (e) {
    const currentDIV = e.currentTarget;
    const divID = e.currentTarget.id;

    if (divID === 'firstLink') {
        setTimeout(() => {
            link1Active();
            scrollToFirstSection.scrollIntoView({
                block: 'nearest',
            });
        }, 30);
    }
    if (divID === 'secLink') {
        setTimeout(() => {
            link2Active();
            scrollToSecondSection.scrollIntoView({
                block: 'center',
            });
        }, 30);
    }
    if (divID === 'lastLink') {
        setTimeout(() => {
            link3Active();
            scrollToLastSection.scrollIntoView({
                block: 'center',
            });
        }, 30);
    }
};
// get all navbar links
for (let i = 0; i < articleNavbarLinks.length; i++) {
    articleNavbarLinks[i].addEventListener(
        'click',
        clickNavbarLinkFunction,
        false
    );
}

// function for show and hide navbar
const navHeight = 70;
let lastScrollY = 0;
const delta = 10;
const isMobile = window.matchMedia(
    'only screen and (max-width: 991px)'
).matches;
let didScroll = false;

window.addEventListener('scroll', (e) => {
    if (isMobile) {
        showOrHideNav();
    }
});
window.addEventListener('resize', function () {
    const win = this;
    if (win.innerWidth < 991) {
        showOrHideNav();
    } else {
        return true;
    }
});

function showOrHideNav() {
    didScroll = true;
    setInterval(() => {
        if (didScroll) {
            scrolled();
            didScroll = false;
        }
    }, 250);
}

function scrolled() {
    const sy = window.scrollY;
    // only trigger if scrolled more than delta
    if (Math.abs(lastScrollY - sy) > delta) {
        // scroll down -> hide nav bar
        if (sy > lastScrollY && sy > navHeight) {
            navbar.classList.add('nav-up');
        }
        // scroll up -> show nav bar
        else if (sy < lastScrollY) {
            navbar.classList.remove('nav-up');
        }
        // update current scroll point
        lastScrollY = sy;
    }
}
